import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import pathToRegexp from 'path-to-regexp';
import { find } from 'lodash';
import classNames from 'classnames';
import { getScrollOpacities } from '../helpers';

class Header extends Component {
  constructor(props){
    super(props);

    this.state = {
      client: null,
      leavingOpacity: 1,
      comingOpacity: 0
    };
  }
  componentWillReceiveProps(newProps){
    this.checkForClient(newProps);
  }

  componentDidMount(){
    this.checkForClient(this.props);
  }

  componentWillMount(){
    window.addEventListener('scroll', this.checkScrollPosition);
    window.addEventListener('resize', this.checkScrollPosition);
  }

  componentWillUnmount(){
    window.removeEventListener('scroll', this.checkScrollPosition);
    window.removeEventListener('resize', this.checkScrollPosition);
  }

  checkForClient(props){
    const re = pathToRegexp('/client/:slug');
    const result = re.exec(props.location.pathname);
    const { clients } = this.props;

    if(result && clients){
      const slug = result[1];
      const client = find(clients, {'slug': slug});
      this.setState({client});
    }else{
      this.setState({client: false});
    }
  }
  checkScrollPosition = event => {
    this.setState(getScrollOpacities(event));
  }
  render() {
    const { client } = this.state;

    return (
      <header className={classNames('header', {
        'header--information': this.props.location.pathname === '/information',
        'header--client': this.props.location.pathname.includes('/client/')
      })}>
        <div className="wrapper wrapper--flex">
          <NavLink exact to="/" className="header__logo__link">
            <span className="header__logo">Onefortysix</span>
            <span className={classNames('header__logo__claim', this.props.state)}>
              <span className="header__logo__claim__wrapper" style={{opacity: client ? this.state.leavingOpacity : 1}}>
                {client ? [
                  <span className="claim__x" key="x"></span>,
                  <span className="claim__client" key="client">
                    {client.title.rendered}
                  </span>
                  ]
                : <span className="claim__text">
                    is a design & development studio
                  </span>
                }
              </span>
            </span>
          </NavLink>
          <NavLink to="/information" className="text-right">Information</NavLink>
        </div>
      </header>
    );
  }
}

export default withRouter(Header);
